import { API } from "aws-amplify";
import { useState } from "react";
import useUIState from "../../hooks/useUIstate";
import { useTranslation } from 'react-i18next';

function ExportTransactionsButton() {
  const { setShowLoadingModal, setToastMessage, setShowToastMessage, setToastType } = useUIState();
  const currentMonth = new Date().getMonth() + 1; // getMonth() is 0-based
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const { t } = useTranslation();
  const months = [
    { name: t('generic.months.january'), value: 1 },
    { name: t('generic.months.february'), value: 2 },
    { name: t('generic.months.march'), value: 3 },
    { name: t('generic.months.april'), value: 4 },
    { name: t('generic.months.may'), value: 5 },
    { name: t('generic.months.june'), value: 6 },
    { name: t('generic.months.july'), value: 7 },
    { name: t('generic.months.august'), value: 8 },
    { name: t('generic.months.september'), value: 9 },
    { name: t('generic.months.october'), value: 10 },
    { name: t('generic.months.november'), value: 11 },
    { name: t('generic.months.december'), value: 12 },
  ];
  const handleExport = async () => {
    setShowLoadingModal(true);
    API.get("AE", `/Dashboard/GetExportTransactionsLink?month=${selectedMonth}`, { response: true })
      .then(async response => {
        const url = response.data.url;
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(error => {
        console.log(error);
        setToastType("error");
        setToastMessage(t('exporttransactionsbutton.error.exporting-transactions'));
        setShowToastMessage(true);
      })
      .finally(() => {
        setShowLoadingModal(false)
      })

  };

  return (
    <div>
      <select value={selectedMonth} onChange={e => setSelectedMonth(Number(e.target.value))}>
        {months.map(month => (
          <option key={month.value} value={month.value}>{month.name}</option>
        ))}
      </select>
      <button onClick={handleExport} style={{ marginLeft: 8 }}>
        {t('exporttransactionsbutton.export-transactions')}
      </button>
    </div>
  );

};

export default ExportTransactionsButton;